let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("751xN")).then(() => parcelRequire('1chQi'));